import React, { Component } from "react";
//import {FormGroup,FormControl,ControlLabel,InputGroup,Dropdown,DropdownButton,MenuItem,ButtonToolbar,NavItem } from 'react-bootstrap';
import { DropdownButton, MenuItem, ButtonToolbar, Dropdown, SplitButton } from 'react-bootstrap';

import Calendar from 'react-calendar';
// import {OnGetJson,OnGetJsoni,GetCorService,GetCorServicei,INSCorServicePost,INSCorServicePostTest} from './../_getjson';
import { genURL } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import BasicSelect from "../Components/CustomSelect/SelectForm";
import axios from 'axios'
/* import styled from 'styled-components';

const x = styled.h6`
width: 400px;
height: 300px;
background-color: #DCDCDC;
overflow: scroll;`;

const Title = styled.h1`
  font-size: 1.5em;
  text-align: center;
  color: palevioletred;
`;

const drp = styled.h1`
  overflow: scroll;
    height:20px;
  color: palevioletred;
`;

const divpattycash = styled.div`
overflow:scroll;
height:100px;
background-color: #DCDCDC` */


/* require('./../_css/SelectFix.css'); */

export default class SelectFix extends Component {
    state = {
        MenuItem: "",
    }
    CalendarOnChange = (data) => {
        var Backup = "";
        var today = new Date(data);
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd }
        if (mm < 10) { mm = '0' + mm }
        today = dd + '/' + mm + '/' + (yyyy + 543);

        setTimeout(() => {
            Backup = this.state.MenuItem;
            this.setState({ MenuItem: "" });
        }, 0);
        setTimeout(() => {
            this.setState({ MenuItem: Backup });
        }, 500);
        this.onClickMenu(today);
        return today;
    }
    //_object = object


    GetDropdownApi = (list) => {
        
        this.setState({
            MenuItem:
                <DropdownButton bsSize="xsmall" id="dropdown-button-drop-left" dropup pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default" style={{ height: '190', overflow: 'auto' }} >
                    {list.map(function (_object, i) { return list[i]; })}
                </DropdownButton>
        });
    }
    componentDidMount() {
        switch (this.props.type) {
            case "typeCar":
                this.props.SelectSetData(this.props.type, "ขายสินค้า");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" dropup pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "11")}>รถใหม่</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "12")}>รถเก่า</MenuItem>
                        </DropdownButton>
                }); break;
            case "SaleType":
                this.onClickMenu("0");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0")}>ขายสินค้า</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1")}>บริการมีภาษี หัก ณ ที่จ่าย</MenuItem>
                        </DropdownButton>
                }); break;
 
            case "BuyType":
                this.onClickMenu("0");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0")}>ซื้อสินค้า</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1")}>บริการมีภาษี หัก ณ ที่จ่าย</MenuItem>
                        </DropdownButton>
                }); break;
            case "PriceType":
                this.onClickMenu("1");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0")}>ราคาไม่รวมภาษี</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1")}>ราคารวมภาษี</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2")}>ภาษีอัตราศูนย์</MenuItem>
                        </DropdownButton>
                }); break;
            case "STOCKPROC":
                this.onClickMenu("1");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0")}>ขอรับคืนสินค้าและลดหนี้</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1")}>ลดหนี้เนื่องจากราคาผิด</MenuItem>
                        </DropdownButton>
                }); break;
            case "ReserveType":
                this.props.SelectSetData(this.props.type, "1");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "1")}>จองกันสต็อก</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2")}>จองสั่งซื้อล่วงหน้า</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "3")}>จองสั่งผลิดสินค้า</MenuItem>
                        </DropdownButton>
                }); break;
            case "BookType":
                this.props.SelectSetData(this.props.type, "จองกันสต็อก");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "จองกันสต็อก")}>จองกันสต็อก</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "จองสั่งซื้อล่วงหน้า")}>จองสั่งซื้อล่วงหน้า</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "จองสั่งผลิตสินค้า")}>จองสั่งผลิตสินค้า</MenuItem>
                        </DropdownButton>
                }); break;
            case "ReturnType":
                this.props.SelectSetData(this.props.type, "1");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "1")}>ขอรับคืนสินค้าและ</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2")}>ขอรับคืนสินค้าและ</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "3")}>ขอรับคืนสินค้าและ</MenuItem>
                        </DropdownButton>
                }); break;
            case "dataGroupYamaha":
                this.props.SelectSetData(this.props.type, "1");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "5")}>เปิดบิลรอเก็บเงิน</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "6")}>เงินสด</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "7")}>ไม่มีจำนวนเงิน</MenuItem>
                        </DropdownButton>
                }); break;
            case "PriceReturnType":
                this.props.SelectSetData(this.props.type, "0");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0")}>คืนเงินสด</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1")}>เอาไว้หักชำระหนี้</MenuItem>
                        </DropdownButton>
                }); break;
            case "Calendar": case "Calendar1": case "Calendar2": case "Calendar3": case "Calendarat": case "dateRegist": case "withdrawaldate": case "scheduledreturn": case "Calendartable":
                this.CalendarOnChange(new Date());
                this.setState({
                    MenuItem:
                        <DropdownButton id="dropdown-basic-button" pullRight noCaret title={
                            <i className="fas fa-calendar-alt"></i>
                            //  <i className="fas fa-calendar-alt selectFix"></i>
                        } bsStyle="default">
                            <Calendar onChange={this.CalendarOnChange} /* value={this.state.date} */ className={"menu1"} />
                        </DropdownButton>
                }); break;
            case "Calendar-up": case "Calendar1-up": case "Calendar2-up": case "Calendar3-up":
                this.CalendarOnChange(new Date());
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" dropup id="split-button-dropup" pullRight noCaret title={<i className="fas fa-calendar-alt selectFix"></i>} bsStyle="default">
                            <Calendar onChange={this.CalendarOnChange} value={this.state.date} className={"menu1"} />
                        </DropdownButton>
                }); break;
            case "brandname": case "brandname1": case "brandname2":
                this.props.SelectSetData(this.props.type, "");

                let url = "/CSPDSUBGROUP2/GetAll?";
                var list = [];
                axios.get(genURL(url)).then(res => {
                    for (let index = 0; index < res.data.length; index++) {
                        list[index] = <MenuItem key={index} onClick={this.onClickMenu.bind(null, res.data[index].CODE)}>{res.data[index].MYNAMETH}</MenuItem>;
                        if (list.length === res.data.length) {
                            this.GetDropdownApi(list);
                        }
                    }
                }); break;
            case "model":
                let url_m = "CSPDSUBGROUP3/GetAll?top=500";
                var list = [];
                axios.get(genURL(url_m)).then(res => {
                    for (let index = 0; index < res.data.length; index++) {
                        list[index] = <MenuItem key={index} onClick={this.onClickMenu.bind(null, res.data[index].CODE)}>{"( " + res.data[index].CODE + " )-" + res.data[index].MYNAMETH}</MenuItem>;
                        if (list.length === res.data.length) {
                            this.GetDropdownApi(list);
                        }
                    }
                }); break;
            case "BOOKNO": case "BOOKNO1":
                this.props.SelectSetData(this.props.type, "");
                let url_b = "CSBOOKNO/getdata?top=10";
                var list = [];
                axios.get(genURL(url_b)).then(res => {
                    if (res.data === undefined) {
                        return
                    }
                    // console.log("res"+res); 
                    for (let index = 0; index < res.data.length; index++) {
                        list[index] = <MenuItem key={index} onClick={this.onClickMenu.bind(null, res.data[index].BOOKNO, res.data[index].BOOKNO + "-" + res.data[index].BANKNAME)}>{"( " + res.data[index].BOOKNO + " )-" + res.data[index].BANKNAME}</MenuItem>;
                        if (list.length === res.data.length) {
                            this.GetDropdownApi(list);
                        }
                    }
                }); break;
            case "Csbank":
                this.props.SelectSetData(this.props.type, "");
                let url_ba = "CSBANKCASHIN/Csbank?ALL";
                var list = [];
                axios.get(genURL(url_ba)).then(res => {
                    // console.log("res"+res); 
                    if (res.data === undefined) {
                        return
                    }
                    for (let index = 0; index < res.data.length; index++) {
                        list[index] = <MenuItem key={index} onClick={this.onClickMenu.bind(null, res.data[index].CODE, res.data[index].CODE + "-" + res.data[index].MYNAMETH)}>{"( " + res.data[index].CODE + " )-" + res.data[index].MYNAMETH}</MenuItem>;
                        if (list.length === res.data.length) {
                            this.GetDropdownApi(list);
                        }
                    }
                }); break;
            case "Credittype":
                this.props.SelectSetData(this.props.type, "");
                let url_c = "CSBANKCASHIN/Credittype?";
                var list = [];
                axios.get(genURL(url_c)).then(res => {
                    // console.log("res"+res); 
                    for (let index = 0; index < res.data.length; index++) {
                        list[index] = <MenuItem key={index} onClick={this.onClickMenu.bind(null, res.data[index].CODE, res.data[index].CODE + "-" + res.data[index].MYNAMETH)}>{"( " + res.data[index].CODE + " )-" + res.data[index].MYNAMETH}</MenuItem>;
                        if (list.length === res.data.length) {
                            this.GetDropdownApi(list);
                        }
                    }
                }); break;
            case "Bankbranch":
                this.props.SelectSetData(this.props.type, "");
                let url_bar = "CSBANKCASHIN/Bankbranch?";
                var list = [];
                axios.get(genURL(url_bar)).then(res => {
                    // console.log("res"+res); 
                    for (let index = 0; index < res.data.length; index++) {
                        list[index] = <MenuItem key={index} onClick={this.onClickMenu.bind(null, res.data[index].bankbranch)}>{res.data[index].bankbranch}</MenuItem>;
                        if (list.length === res.data.length) {
                            this.GetDropdownApi(list);
                        }
                    }
                }); break;
            case "CashReceipt3":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, this.props.cdata)}>{this.props.cdata}</MenuItem>
                        </DropdownButton>
                }); break;
            case "keyIcon":
                // this.props.SelectSetData(this.props.type,"0|ไม่ควบคุม");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ไม่ควบคุม")}>ไม่ควบคุม</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ควบคุม")}>ควบคุม</MenuItem>

                        </DropdownButton>
                }); break;
            case "Fee":
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|บริษัทออกให้")}>บริษัทออกให้</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ลูกค้าจ่ายเองให้หักในบัตร")}>ลูกค้าจ่ายเองให้หักในบัตร</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2|ลูกค้าจ่ายเงินสด")}>ลูกค้าจ่ายเงินสด</MenuItem>
                            {/* <MenuItem onClick={this.onClickMenu.bind(null, "")}>-</MenuItem> */}
                        </DropdownButton>
                }); break;
            case "_prefix":
                // this.props.SelectSetData(this.props.type,"0|ไม่ควบคุม");
                let url_prefix = "PSPREFIX/ALL?MFLAG=1";
                var list_prefix = [];
                axios.get(genURL(url_prefix)).then(res => {
                    for (let index = 0; index < res.data.length; index++) {
                        list_prefix[index] = <MenuItem key={index} onClick={this.onClickMenu.bind(null, res.data[index].MYNAMETH)}>{res.data[index].MYNAMETH}</MenuItem>;
                        if (list_prefix.length === res.data.length) {
                            this.GetDropdownApi(list_prefix);
                        }
                    }
                });
                break;
            case "CSPETTYCASH":
                // this.props.SelectSetData(this.props.type,"0|ไม่ควบคุม");
                let url_CSPETTYCASH = "CSPETTYCASH/getAll?";
                var list_CSPETTYCASH = [];
                axios.get(genURL(url_CSPETTYCASH)).then(res => {
                    for (let index = 0; index < res.data.length; index++) {
                        list_CSPETTYCASH[index] = <MenuItem onClick={this.onClickMenu.bind(null, res.data[index].MYNAMETH)}>{res.data[index].MYNAMETH}</MenuItem>;
                        if (list_CSPETTYCASH.length === res.data.length) {
                            this.GetDropdownApi(list_CSPETTYCASH);
                        }
                    }
                });
                break;
            case "ProductType":
                this.onClickMenu("0");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0")}>สินค้าซื้อมาขายไป</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1")}>สินค้าบริการ</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2")}>ไม่มีสต็อก (ทรัพย์สิน)</MenuItem>
                        </DropdownButton>
                }); break;

            case "checkkm":
                let url_PSCHEACKKM = "PSCHEACKKM/GetAll?";
                var list_PSCHEACKKM = []; 
                axios.get(genURL(url_PSCHEACKKM)).then(res => {
                    console.log('res',res);
                    for (let index = 0; index < res.data.length; index++) {
                        list_PSCHEACKKM[index] = <MenuItem key={index} onClick={this.onClickMenu.bind(null, res.data[index].CODE + "|" + res.data[index].MYNAMETH)}>{res.data[index].MYNAMETH}</MenuItem>;
                        if (list_PSCHEACKKM.length === res.data.length) {
                            this.GetDropdownApi(list_PSCHEACKKM);
                        }
                    }
                });
                break;
        }
    }
    onClickMenu = (data, data1) => {
        this.props.SelectSetData(this.props.type, data, data1, this.props.name);
    }
    render() {
        return (
             <ButtonToolbar  >
                {this.state.MenuItem}  
             </ButtonToolbar>
 
           
        )
    }
}
// export class SelectFixTest extends Component {
//     state = {
//         MenuItem: [],
//         Class1: "dropClick",
//     }
//     componentDidMount() {
//         var url = "CSINCOME/ALL?MFLAG=1";
//         var data_ = this.state.MenuItem;
//         axios.get(genURL(url)).then(res => {
//             for (var i = 0; i < res.data.length; i++) {
//                 data_[i] = {
//                     MYNAMETH: res.data[i].MYNAMETH
//                 }
//                 if (i === res.data.length) {
//                     this.setState({ MenuItem: data_ });
//                 }
//             }
//         });
//     }
//     onClickMenu = (data) => {
//         console.log(data);
//     }
//     onDrop = (e) => {
//         this.setState({ Class1: "dropClick active" });
//     }
//     onUnDrop = (e) => {
//         this.setState({ Class1: "dropClick" });
//         console.log("onUnDrop");
//     }
//     onRowClick = (e) => {
//         console.log(e);
//     }
//     render() {
//         return (
//             <div className="MainDrop" align="center">
//                 <button Class="BTNDrop" onClick={this.onDrop} onBlurCapture={this.onUnDrop}><i className="fas fa-spider"></i></button>
//                 <div className={this.state.Class1} align="left" >
//                     {this.state.MenuItem.map(function (Item, i) {
//                         return <div>{Item.MYNAMETH}</div>;
//                     })}
//                 </div>
//             </div>
//         )
//     }
// }

export class SelectFix_DATE extends Component {
    state = {
        popupCalendar: false,
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (event.target.className === "popupSelectFixBG") {
            this.setState({ popupCalendar: false });
        }
    }
    CalendarOnChange = (data) => {
        var Backup = "";
        var today = new Date(data);
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd }
        if (mm < 10) { mm = '0' + mm }
        today = dd + '/' + mm + '/' + (yyyy + 543);
        this.props.getDate_Table(today);
        this.popupCalendar();
    }

    popupCalendar = () => {
        this.setState({ popupCalendar: !this.state.popupCalendar });
    }
    render() {
        return (
            <div align="canter" >
                <div onClick={this.popupCalendar} >
                    <i className="fas fa-calendar-alt"></i>
                </div>
                {this.state.popupCalendar ?
                    <div className="" id="CalendarDrop"
                        style={{ position: "absolute", zIndex: '1000', right: '10%', display: 'block' }}
                    >
                        <div className="popupSelectFixBG" id="popupSelectFixBG"></div>
                        <Calendar onChange={this.CalendarOnChange} className={"menu1 popupSelectFix"} />
                    </div>
                    : null}
            </div>
        )
    }
}

export class SelectFix_UNIT extends Component {
    state = {
        popupCalendar: false,
        value: "coconut"
    }
    componentDidMount() {
        this.LoadData();
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside = (event) => {
        if (event.target.className === "popupSelectFixBG") {
            this.setState({ popupBootstrapTable: false });
        }
    }
    popupBootstrapTable = () => {
        this.setState({ popupBootstrapTable: !this.state.popupBootstrapTable });
    }
    LoadData = () => {
        var url = "CSUNIT/GetAll?MFLAG=1";
        var OPTArray = [];
        axios.get(genURL(url)).then(res => {
            for (var i = 0; i < res.data.length; i++) {
                OPTArray[i] = {
                    C0: res.data[i].CODE,
                    UnitName: res.data[i].MYNAMETH,
                }
            }
            this.setState({ dataTable1: OPTArray });
        });
    }
    onSelectRowDocNoRef = (row, col, id) => {
        this.props.getUnit_Table(row.UnitName);
        this.popupBootstrapTable();
    }
    render() {
        return (
            <div style={{ paddingTop: "5px" }} align="canter">
                <div onClick={this.popupBootstrapTable}>
                    <i className="fas fa-caret-square-down"></i>
                </div>
                {this.state.popupBootstrapTable ?
                    <div className="divDop" id="CalendarDrop">
                        <div className="popupSelectFixBG" id="popupSelectFixBG"></div>
                        <div className="popupSelectFix SelectFixDivTable">
                            <BootstrapTable
                                data={this.state.dataTable1}
                                options={{
                                    onRowClick: this.onSelectRowDocNoRef,
                                    noDataText: this.state.loadding
                                }}
                                height="250"
                                search={true} multiColumnSearch={true}
                                hover condensed
                            >
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='C0' isKey width="25%" dataAlign="center">UnitCode</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='UnitName' dataAlign="left" width="75%" > <div align="center"> UnitName </div> </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                    : null}
            </div>
        )
    }

}

// className เลือกเงินสดย่อย 
export class Selectcspattycash extends Component {
    state = {
        popupCalendar: false,
        value: "CSPETTYCASH"
    }
    componentDidMount() {
        this.LoadData();
        // document.addEventListener('mousedown', this.handleClickOutside);
    }
    // handleClickOutside = (event) => {
    //     if (event.target.className === "popupSelectFixBG") {
    //         this.setState({ popupBootstrapTable: false });
    //     }
    // }
    // popupBootstrapTable = () => {
    //     this.setState({ popupBootstrapTable: !this.state.popupBootstrapTable });
    // }
    LoadData = () => {
        var url = "CSPETTYCASH/getAll?";
        var OPTArray = [];
        axios.get(genURL(url)).then(res => {
            for (var i = 0; i < res.data.length; i++) {
                OPTArray[i] = {
                    _code: res.data[i].CODE,
                    _name: res.data[i].MYNAMETH,
                }
            }
            this.setState({ dataTable1: OPTArray });
        });
    }
    onSelectRowDocNoRef = (row, col, id) => {
        // this.props.getUnit_Table(row.UnitName);
        // this.popupBootstrapTable();
    }
    render() {
        return (
            <div style={{ paddingTop: "5px" }} align="canter">
                <div onClick={this.popupBootstrapTable}>
                    <i className="fas fa-caret-square-down"></i>
                </div>
                {this.state.popupBootstrapTable ?
                    <div className="divDop" id="CalendarDrop">
                        <div className="popupSelectFixBG" id="popupSelectFixBG"></div>
                        <div className="popupSelectFix SelectFixDivTable">
                            <BootstrapTable
                                data={this.state.dataTable1}
                                options={{
                                    onRowClick: this.onSelectRowDocNoRef,
                                    noDataText: this.state.loadding
                                }}
                                height="250"
                                search={true} multiColumnSearch={true}
                                hover condensed
                            >
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='_code' isKey width="25%" dataAlign="center">code</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='_name' dataAlign="left" width="75%" > <div align="center"> name </div> </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                    : null}
            </div>
        )
    }

}



